import addressbook from "./addressbook";

export default {
  en: {
    messages: {
      attemptreenable:"Attempt to re-enable",
      updatepaymentmethod:"Update payment method",
      subscriptionpastdue:"A subscription payment is past due. Please update your payment method to avoid service interruption.",
      subscriptionunpaid:"A subscription payment has failed. Please update your payment method to restore service.",
      subscriptioncanceled:"A subscription has been canceled.",
      loading:"Loading...",
      yourdetails:"Your details",
      username:"Username",
      email:"Billing email",
      billingdetails:"Billing details",
      changepassword:"Change password",
      deleteaccount:"Delete account",
      key:"Key",
      copy:"Copy",
      copying:"Copied!",
      change:"Change",
      paymentmethod:"Payment method",
      nopaymentmethod:"No payment method",
      accountdetails: "Account details",
      updatecustomerinfo: "Address, tax & invoices",
      recentusage:"Recent Usage",
      usage:"Usage",
      todayqueries:"Today",
      periodqueries:"This period",
      queries:"queries",
      cost:"cost",
      openingPaymentPage: "Opening the payment processing page...",
      notsignedin:"You aren't signed into an account. Please {0} to access account information.",
      signin:"sign in",
      signinrequired:"Sign in required",
      signinrequireddesc:"Please sign in to access account information.",
      confirmDeleteTitle: "Confirm account deletion",
      confirmDeleteDesc: "This will immediate disable your account and schedule your account for deletion. If you have a subscription, it will be cancelled and you won't be charged again. Please confirm that you want to delete your account.",
      confirmReenableTitle: "Confirm re-enabling attempt",
      confirmReenableDesc: "We will attempt to reenable your account. Multiple account disable events will require a longer waiting time and may cause a permanent ban.",
      confirmApiKeyChangeTitle: "Confirm changing the API key",
      confirmApiKeyChangeDesc: "Your API key will be changed immediately. Queries using the old key will fail. Please confirm that you want to change your key.",
      createsecret:"Create a new secret key",
      confirmSecretChangeTitle: "Confirm creating a new secret key",
      confirmSecretChangeDesc: "This will create a new secret key for your account. The old secret key will be invalidated and cannot be used anymore. Please confirm that you want to create a new secret key.",
      secretkeymodaltitle: "New secret",
      yournewsecretkey: "Your new secret",
      copysecretkeywarning: "Please copy your new secret key now. You won't be able to see it again.",
      changeusername:"Change username",
      newemailaddress:"New email address",
      newemailplaceholder:"Enter new email address",
      sendverificationcode:"Send verification code",
      verificationcodesent:"A verification code has been sent to the new email address. Please enter the code below.",
      verificationcode:"Verification code",
      entercode:"Enter code",
      requestnewcode:"Request a new code",
      requestnewcodein:"Request a new code in {seconds}s",
      pwdcodeinstructions:"A verification code will be sent to your account email address.",
      updatebillingemail:"Also update billing email address",
      confirm:"Confirm",
      cancel:"Cancel",
      emailnotavailable:"This email address is already in use.",
      usernamechanged:"Username changed",
      usernamechangeddesc:"Your username has been changed successfully. A confirmation email has been sent to both your old and new email addresses.",
      addressbook: "Address Book",
      emailprefs: {
        title: 'Communication Preferences',
        service: 'Service notifications (billing, security, password resets)',
        news_and_announcements: 'Tips, tutorials, product announcements & news',
        marketing: 'Promotions & special offers',
        save: 'Save preferences',
        saving: 'Saving...',
        saved: 'Preferences saved!',
        error: 'Error saving preferences. Please try again.',
        close: 'Close',
      },
    }
  },
  de: {
    messages: {
      attemptreenable: "Versuch, erneut zu aktivieren",
      updatepaymentmethod: "Zahlungsmethode aktualisieren",
      subscriptionpastdue: "Eine Abonnementzahlung ist überfällig. Bitte aktualisieren Sie Ihre Zahlungsmethode, um eine Dienstunterbrechung zu vermeiden.",
      subscriptionunpaid: "Eine Abonnementzahlung ist fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsmethode, um den Dienst wiederherzustellen.",
      subscriptioncanceled: "Ein Abonnement wurde gekündigt.",
      loading: "Lädt...",
      yourdetails: "Ihre Details",
      username: "Benutzername",
      email: "Rechnungs-E-Mail",
      billingdetails: "Rechnungsdetails",
      changepassword: "Passwort ändern",
      deleteaccount: "Konto löschen",
      key: "Schlüssel",
      copy: "Kopieren",
      copying:"Kopiert!",
      change: "Ändern",
      paymentmethod: "Zahlungsmethode",
      nopaymentmethod: "Keine Zahlungsmethode",
      accountdetails: "Kontodetails",
      updatecustomerinfo: "Adresse, Steuer & Rechnungen",
      recentusage: "Letzte Nutzung",
      usage: "Nutzung",
      todayqueries: "Heute",
      periodqueries: "Dieser Zeitraum",
      queries: "Abfragen",
      cost: "Kosten",
      openingPaymentPage: "Öffne die Zahlungsabwicklungsseite...",
      notsignedin: "Sie sind nicht an einem Konto angemeldet. Bitte {0}, um auf Kontoinformationen zuzugreifen.",
      signin: "Anmelden",
      signinrequired: "Anmeldung erforderlich",
      signinrequireddesc: "Bitte melden Sie sich an, um auf Kontoinformationen zuzugreifen.",
      confirmDeleteTitle: "Löschen des Kontos bestätigen",
      confirmDeleteDesc: "Ihr Konto wird hiermit sofort deaktiviert und zur Löschung vorgemerkt. Bestehende Abonnements werden gekündigt und nicht weiter berechnet. Bitte bestätigen Sie, dass Sie Ihr Konto endgültig löschen möchten.",
      confirmReenableTitle: "Wiederherstellungsversuch bestätigen",
      confirmReenableDesc: "Wir werden versuchen, das Konto wiederherzustellen. Mehrere Deaktivierungen des Kontos führen zu längeren Wartezeiten und können zu einer dauerhaften Sperrung führen.",
      confirmApiKeyChangeTitle: "Änderung des API-Schlüssels bestätigen",
      confirmApiKeyChangeDesc: "Der API-Schlüssel wird sofort geändert. Anfragen mit dem alten Schlüssel werden fehlschlagen. Änderung des API-Schlüssels bestätigen.",
      createsecret: "Neuen geheimen Schlüssel erstellen",
      confirmSecretChangeTitle: "Erstellen eines neuen geheimen Schlüssels bestätigen",
      confirmSecretChangeDesc: "Dies erstellt einen neuen geheimen Schlüssel für Ihr Konto. Der alte Schlüssel wird ungültig und kann nicht mehr verwendet werden. Bitte bestätigen Sie, dass Sie einen neuen geheimen Schlüssel erstellen möchten.",
      secretkeymodaltitle: "Neuer geheimer Schlüssel",
      yournewsecretkey: "Ihr neuer geheimer Schlüssel",
      copysecretkeywarning: "Bitte kopieren Sie jetzt Ihren neuen geheimen Schlüssel. Sie werden ihn später nicht mehr einsehen können.",
      changeusername:"Benutzername ändern",
      newemailaddress:"Neue E-Mail-Adresse",
      newemailplaceholder:"Neue E-Mail-Adresse eingeben",
      sendverificationcode:"Bestätigungscode senden",
      verificationcodesent:"Ein Bestätigungscode wurde an die neue E-Mail-Adresse gesendet. Bitte geben Sie den Code unten ein.",
      verificationcode:"Bestätigungscode",
      entercode:"Code eingeben",
      requestnewcode:"Neuen Code anfordern",
      requestnewcodein:"Neuen Code anfordern in {seconds}s",
      pwdcodeinstructions:"Ein Bestätigungscode wird an Ihre E-Mail-Adresse gesendet.",
      updatebillingemail:"Auch die Rechnungs-E-Mail-Adresse aktualisieren",
      confirm:"Bestätigen",
      cancel:"Abbrechen",
      emailnotavailable:"Diese E-Mail-Adresse wird bereits verwendet.",
      usernamechanged:"Benutzername geändert",
      usernamechangeddesc:"Ihr Benutzername wurde erfolgreich geändert. Eine Bestätigungs-E-Mail wurde an Ihre alte und neue E-Mail-Adresse gesendet.",
      emailprefs: {
        title: 'Kommunikationseinstellungen',
        service: 'Service-Benachrichtigungen (Rechnungsstellung, Sicherheit, Passwort-Zurücksetzung)',
        news_and_announcements: 'Tipps, Tutorials, Produktankündigungen & Neuigkeiten',
        marketing: 'Aktionen & Sonderangebote',
        save: 'Einstellungen speichern',
        saving: 'Wird gespeichert...',
        saved: 'Einstellungen gespeichert!',
        error: 'Fehler beim Speichern der Einstellungen. Bitte versuchen Sie es erneut.',
        close: 'Schließen',
      },
    }
  },
};
